
import { useMutation } from "react-query"
import { useToast } from "../../hook/usetoast";
import DataService from '../../config/DataServices'

const { postRequest} = DataService()






export const useSubscription = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/update_newsletter", { ...data })
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }
            return toast.success(success?.message)
        }
    })
}
